<template>
    <main class="flex flex-col md:flex-row md:gap-6">
        <div class="order-last md:order-none h-[214px] md:h-full md:w-2/5 lg:w-1/3 pl-3.5 md:p-6 bg-cloud-dark">
            <step-options />
        </div>

        <div class="order-first md:order-none grow md:w-6/12 lg:w-1/3 md:p-6">
            <product-renderer v-if="isMobile" />
        </div>

        <step-navigation v-if="isMobile" />

        <div class="my-5 md:my-0 order-2 md:w-2/5 lg:w-1/3 px-3.5 md:p-6 xl:pl-32 flex flex-col xl:justify-center">
            <step-description class="bg-cloud-dark" />
        </div>
    </main>
</template>

<script>
    import allStores from '../stores/all';

    import StepOptions from './StepOptions.vue';
    import StepDescription from './StepDescription.vue';
    import ProductRenderer from './ProductRenderer.vue';
    import StepNavigation from './StepNavigation.vue';

    export default {
        mixins: [allStores],

        components: {
            StepOptions,
            StepDescription,
            ProductRenderer,
            StepNavigation,
        },

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },
        },
    };
</script>
